
    <header class="it-header-wrapper" data-bs-target="#header-nav-wrapper"  #myHeader [innerHTML]="htmlContent"></header>
